var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitterOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 29,
    viewBox: "0 0 33 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2401 0.666504C21.3799 0.666504 19.596 1.40147 18.2806 2.70971C16.9653 4.01795 16.2264 5.7923 16.2264 7.64243C16.2264 7.82398 15.8877 7.92994 15.2955 7.92994C13.0309 7.92994 7.06358 6.37737 2.19891 1.53808C0.445478 5.02605 -0.431651 13.7468 10.9669 19.8511C7.01816 23.4097 2.59287 24.536 0.167969 24.5368C0.262124 24.6732 0.342238 24.8161 0.443826 24.9483C2.52267 27.6485 6.54408 28.9998 10.9074 28.9998C15.1948 28.9998 19.8117 27.6953 23.2417 25.0831C28.4632 21.1071 30.2555 14.6184 30.2555 7.64243V6.77003L32.668 1.50769L27.5192 2.12215C26.2945 1.1786 24.7892 0.666557 23.2401 0.666504Z",
    fill: "#FF5D0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterOrange);
export default __webpack_public_path__ + "static/media/TwitterOrange.7303471d0837aa161ebcbd22da028797.svg";
export { ForwardRef as ReactComponent };